import { render, staticRenderFns } from "./UserTypeModal.vue?vue&type=template&id=736daf23"
import script from "./UserTypeModal.vue?vue&type=script&lang=js"
export * from "./UserTypeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports